import { memo } from 'react';
import { convertBroadcastReason } from '../utils';
import SessionThumbnail from '../uiComponents/SessionThumbnail';
import type { SessionPreviewHeaderProps } from './types';
import Icon from '@/components/atoms/Icon';

function SessionPreviewHeader({
  session,
  canPreviewSession,
  isBatchFailed,
  failedIconName,
  contentStatusText
}: SessionPreviewHeaderProps) {
  if (canPreviewSession) {
    return (
      <div
        className="flex aspect-video grow cursor-pointer items-center justify-center !rounded-t-xl bg-slate-100"
        style={{
          backgroundColor: session.project.theme_obj?.event_background
        }}
        data-testid="session"
      >
        <SessionThumbnail iconSize={30} session={session} />
      </div>
    );
  }

  return (
    <div className="flex aspect-video grow items-center justify-center !rounded-t-xl bg-slate-200">
      <div className="flex flex-col items-center whitespace-normal p-3 text-center text-slate-500">
        {isBatchFailed ? (
          <div className="flex h-12 w-8 items-center justify-center">
            <Icon name={failedIconName} size={24} stroke={1.5} />
          </div>
        ) : (
          <div className="relative" data-testid="processing-icon">
            <Icon name="IconLoader2" size={24} className="animate-spin" />
          </div>
        )}
        <div className="mt-1.5 text-sm">{contentStatusText}</div>
        {session.reason && <div className="text-xs">{convertBroadcastReason(session.reason as string)}</div>}
      </div>
    </div>
  );
}

export default memo(SessionPreviewHeader);
